export default __webpack_public_path__ + "static/media/Saskia_9781846164965.ced3c3c3.jpg";